<template>
    <section>

        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="mb-2" v-if="Object.keys(errores_validacion).length != 0">
                <b-message type="is-danger" has-icon>
                    <div v-for="(item, index) in errores_validacion" :key="index">
                        {{ item[0] }}
                    </div>
                </b-message>
            </div>


            <form @submit.prevent="handleSubmit(saveMyAcademicData)">

                <div class="columns">

                    <div class="column">
                        <ValidationProvider rules="min:3|max:255" v-slot="{ errors, failedRules }">
                            <b-field label="Alias" 
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input type="text" v-model="person.alias"
                                    placeholder="Ingrese Alias"/>
                            </b-field>
                        </ValidationProvider>
                    </div>

                    <div class="column">
                        <ValidationProvider rules="min:0|max:255" v-slot="{ errors, failedRules }">
                            <b-field label="ORCID" 
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input expanded type="text" v-model="person.orcid"
                                    placeholder="Ingrese su ORCID"/>
                                <b-button tag="a"
                                    :href="person.orcid ? 'https://orcid.org/' + person.orcid : 'https://orcid.org/'"
                                    target="_blank" icon-left="external-link-alt" type="is-info" label="Link" />
                            </b-field>
                        </ValidationProvider>
                    </div>

                </div>

                <div class="columns">

                    <div class="column">
                        <ValidationProvider rules="integer|min:0|max:255|positive" v-slot="{ errors, failedRules }">
                            <b-field label="ID Scopus" 
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input expanded type="number" v-model="person.scopus_id"
                                    placeholder="Ingrece su ID Scopus"/>
                                <b-button tag="a" :href="person.scopus_id ? 'https://www.scopus.com/authid/detail.uri?authorId=' + person.scopus_id : 'https://www.scopus.com/'"
                                    target="_blank" icon-left="external-link-alt" type="is-info" label="Link" />
                            </b-field>
                        </ValidationProvider>
                    </div>

                    <div class="column">
                        <ValidationProvider rules="integer|min:0|max:255|positive" v-slot="{ errors, failedRules }">
                            <b-field label="ID Wos"
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input expanded type="number" v-model="person.wos_id"
                                    placeholder="Ingrese su ID Wos" />
                                <b-button tag="a" :href="person.wos_id ? 'https://www.webofscience.com/wos/author/record/' + person.wos_id : 'https://www.webofscience.com/'"
                                    target="_blank" icon-left="external-link-alt" type="is-info" label="Link" />
                            </b-field>
                        </ValidationProvider>
                    </div>

                    <div class="column">
                        <ValidationProvider rules="integer|min:0|max:255|positive" v-slot="{ errors, failedRules }">
                            <b-field label="ID Scielo" 
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input type="number" v-model="person.scielo_id"
                                    placeholder="Ingrese su ID Scielo" />
                            </b-field>
                        </ValidationProvider>
                    </div>

                </div>

                <div class="columns">

                    <div class="column">
                        <ValidationProvider rules="integer|positive|min:0|max:10" v-slot="{ errors, failedRules }">
                            <b-field label="H-Index" 
                                :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                                :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                                <b-input type="number" v-model="person.h_index"
                                    placeholder="Ingrese su H-Index"/>
                            </b-field>
                        </ValidationProvider>
                    </div>

                </div>

                <div v-if="person.can_update_my_academic_activity" class="columns">
                    <div class="column has-text-right">
                        <button type="submit" class="button is-primary" @click="checkValidation">
                            <span class="icon">
                                <i class="fas fa-save"></i>
                            </span>
                            <span>Guardar Datos de Investigación</span>
                        </button>
                    </div>
                </div>

            </form>

        </ValidationObserver>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"/>

    </section>
</template>

<script>
import axios from "axios"
export default {
    props: [
        'personId'
    ],

    data() {
        return {
            isLoading: false,
            person: {},
            errores_validacion:[],
        }
    },

    async created() {
        await this.getPerson();
    },

    methods: {
        async getPerson() {
            this.isLoading = true;
            await axios
                .get("/people/" + this.personId + ".json")
                .then(res => {
                    this.person = res.data
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async checkValidation() {
            const valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    message: 'Algunos campos presentan errores.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
            }
        },


        async saveMyAcademicData() {
            this.isLoading = true
            await axios
                .put("/people/" + this.personId + "/my-academic-data/update.json", {
                    person: this.person,
                },
                )
                .then(response => {
                    this.errores_validacion = []
                    this.$buefy.dialog.alert({
                        title: 'Logrado',
                        message: 'Tus datos de Investigación han sido actualizados satisfactoriamente.',
                        type: 'is-success',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'check-circle',
                        confirmText: 'Ok',
                    })
                    this.getPerson();
                }).
                catch(error => {
                    this.errores_validacion = error.response.data
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al guardar tus datos de Investigación, favor de revisar los errores.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                    var elmnt = document.getElementById("app");
                    elmnt.scrollIntoView();
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

    }
}
</script>